import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { history } from "../../_utils";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Container } from "reactstrap";
import "./App.scss";

import { CNavBar } from "../Shared";

import SideMenu from "../SideMenu";

import { routes } from "../../_constants";

import { alertActions } from "../Alert/actions/alert.actions";

export class App extends Component {
  state = {
    fullWidth: false
  };

  toggleFullWidth = () => {
    this.setState(prevState => ({
      fullWidth: !prevState.fullWidth
    }));
  };

  notify = () => {
    const { type, message, section } = this.props;
    toast[type || "info"](
      <div>
        <p>
          <span className="bold">{section}:</span> {message}
        </p>
      </div>
    );
    this.props.clearAlerts();
  };

  render() {
    const { location, message } = this.props;
    const { fullWidth } = this.state;
    if (message) {
      this.notify();
    }
    return (
      <Router history={history}>
        <div className="App">
          <ToastContainer hideProgressBar autoClose={2000} />
          <SideMenu isFullWidth={fullWidth} location={location} />
          <main className={`main-content ${fullWidth ? "active" : ""}`}>
            <CNavBar toggleFullWidth={this.toggleFullWidth} />
            <Container fluid>
              <Switch>
                {routes.map(route => (
                  <Route
                    key={route.key}
                    exact={route.exact}
                    path={route.path}
                    name={route.name}
                    component={route.pageComponent}
                  />
                ))}
              </Switch>
            </Container>
          </main>
        </div>
      </Router>
    );
  }
}

const mapStateToProps = state => {
  const { type, message, section } = state.alert;

  return {
    type,
    section,
    message
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clearAlerts: bindActionCreators(alertActions.clear, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
